import type { NextPage } from 'next';
import { AboutOurPartnership } from '../../components/About/AboutOurPartnership';
import { Seo } from '../../components/Seo/Seo';

const AboutOurPartnershipPage: NextPage = () => {
  return (
    <>
      <Seo
        title="Our Partners"
        description="None of us are as strong as all of us. We’re proud to have established relationships with key partners ."
      />
      <AboutOurPartnership />
    </>
  );
};

export default AboutOurPartnershipPage;
